/**
 * Відповідність полів модуля «Фінанси робіт» поняттям довідника (підключається в features/knowledge/fieldTerms.ts).
 * Значок «?» з’являється, лише якщо поняття є в словнику сервера. Окремого поняття «Маржа» у словнику немає:
 * «ЧЗ» там визначено як «Чистий заробіток (маржа)», тож маржа веде до нього.
 */
export const FINANCE_FIELD_TERMS: Readonly<Record<string, string>> = {
  'finance.netEarnings': 'ЧЗ',
  'finance.marginPct': 'ЧЗ',
  'finance.rule100': 'Правило 100 USD',
  'finance.km': 'КМ',
  'finance.salesManager': 'МП',
  'finance.exchange': 'Фінпрограма',
};
